const setting = {
  passwordTitle: "Kennwort",
  changePasswordBtn: "Passwort ändern",
  changePasswordTips:
    "Wenn Sie Ihr Passwort vergessen haben oder es ändern möchten, können Sie dies hier tun; wir senden einen Verifizierungscode an Ihre registrierte E-Mail-Adresse, die zur Bestätigung Ihrer Identität überprüft wird, und Sie können Ihr Kontopasswort zurücksetzen.",
  feedbackTitle: "Rückmeldung",
  feedbackBtn: "Rückmeldung abgeben",
  feedbackTips:
    "Damit wir Ihnen besser helfen können, können Sie Ihr Problem hier beschreiben und uns eine Rückmeldung geben. Unser Kundendienst wird sich so schnell wie möglich mit Ihnen in Verbindung setzen.",
  appearanceTitle: "Erscheinungsbild Display",
  appearanceBtn: "Anzeige ändern",
  appearanceTips:
    "Wir bieten Ihnen die Wahl zwischen zwei Erscheinungsmodi, so dass Sie je nach Vorliebe zwischen dunklen und hellen Farben wechseln können.",
  changePassWordModalTitle: "Passwort ändern",
  changePassWordSameErrorTips: "Das neue Passwort, das Sie eingegeben haben, ist dasselbe wie Ihr altes Passwort. Geben Sie ein anderes Passwort ein",
  changePasswordCurrentErrorTips: "Ihr Passwort war falsch. Bitte versuchen Sie es erneut.",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Kennwort",
  retypePasswordLabel: "Neues Kennwort wiederholen",
  changePasswordSuccessTips: "Ihr Passwort wurde erfolgreich geändert.",
  changePasswordComfirmDiffErrorTips: "Bitte geben Sie in beide Felder das gleiche Passwort ein.",
  forgotPassword: "Passwort vergessen?",
  feedbackModalSubtitle: "Vielen Dank, dass Sie sich mit uns in Verbindung gesetzt haben und uns Ihre Meinung zu unserem Produkt mitteilen!",
  feedBackModalProductQuestion: "Welche Art von Problemen möchten Sie mit unserem Produkt lösen？",
  feedBackModalProductTypeSug: "Vorschläge",
  feedBackModalProductTypeMem: "Fragen zum Mitgliederservice",
  feedBackModalProductTypeFun: "Feature-Anfrage",
  feedBackModalProductTypeReq: "Produktanfrage",
  feedBackModalProductTypeBug: "Feedback zu Produktfehlern",
  feedBackModalProductTypeIss: "Performance-Probleme",
  feedBackModalProductTypeRL: "Probleme bei der Registrierung und Anmeldung",
  feedBackModalProductTypeRef: "Erstattungsdienst",
  feedBackModalProductTypeOth: "Andere",
  feedBackModalProductSelectQuestion: "Welche Art von Problemen möchten Sie mit unserem Produkt lösen？",
  feedBackModalProductContQuestion: "Auf welches Problem sind Sie bei der Verwendung des Produkts gestoßen?",
  feedBackModalAddImageBtn: "Bilder hinzufügen",
  feedBackModalTips: "Hinweise:",
  feedBackModalTipsCont:
    "Aufgrund der Zeitverschiebung des globalen Kundendienstes, werden wir Ihnen innerhalb von 48 Stunden des Arbeitstages antworten;",
  feedBackSuccessTips: "Erfolgreich senden",
  feedBackSuccessSubTips: "Wir werden Ihr Problem so schnell wie möglich lösen",
  feedBackFailedTips: "Senden fehlgeschlagen",
  feedBackFailedSubTips: "Bitte stellen Sie sicher, dass Ihre Netzwerkverbindung funktioniert und senden Sie erneut",
  appearanceLightMode: "Heller Modus",
  appearanceDarkMode: "Dunkler Modus",
  promotionModalTitle: "Werbeaktion",
  promoItem: "Promo-Artikel",
  promoCode: "Werbeartikel-Code",
  discount: "Rabatt",
  applyBtn: "Anwenden",
  applyPromotionErrorTips: "Ihr Promo-Code ist ungültig",
};

export default setting;
